import React from "react"
import ThoughtLeadershipComponent from "./ThoughtLeadership"
import thoughtLeadershipFactory from "./thoughtLeadership.factory"

export { default as ThoughtLeadershipQuery } from "./thoughtLeadership.query"

export const ThoughtLeadership = props => {
  const { data } = props
  const componentProps = { ...props, ...thoughtLeadershipFactory.transform(data) }
  return <ThoughtLeadershipComponent {...componentProps} />
}
